import { Component } from '@angular/core';

@Component({
  selector: 'hurrey-scope-potential',
  standalone: true,
  imports: [],
  templateUrl: './hurrey-scope-potential.component.html',
  styleUrl: './hurrey-scope-potential.component.scss'
})
export class HurreyScopePotentialComponent {

}
